import { useState } from 'react';
import {
  PageHeader,
  Screen,
  SegmentedControl,
  type SegmentedOption,
} from '../../shared/ui/index.js';
import { BankSection } from './bank-section/bank-section.js';
import { CardsSection } from './cards-section/cards-section.js';
import { CategoriesSection } from './categories-section/categories-section.js';
import styles from './references-page.module.css';

type ReferenceSection = 'cards' | 'categories' | 'bank';

const SECTION_OPTIONS: SegmentedOption[] = [
  { value: 'cards', label: 'Картки' },
  { value: 'categories', label: 'Категорії' },
  { value: 'bank', label: 'Банк' },
];

const SECTIONS: ReferenceSection[] = ['cards', 'categories', 'bank'];

const sectionOf = (value: string): ReferenceSection =>
  SECTIONS.find((section) => section === value) ?? 'cards';

export const ReferencesPage = () => {
  const [section, setSection] = useState<ReferenceSection>('cards');

  return (
    <Screen>
      <div className={styles.content}>
        <PageHeader title="Довідники" />

        <SegmentedControl
          label="Який довідник"
          name="reference-section"
          options={SECTION_OPTIONS}
          value={section}
          hideLabel
          onChange={(value) => {
            setSection(sectionOf(value));
          }}
        />

        {section === 'cards' && <CardsSection />}
        {section === 'categories' && <CategoriesSection />}
        {section === 'bank' && <BankSection />}
      </div>
    </Screen>
  );
};
